import { getData, postFormData, patchFormData } from "./index";

export const getBespokeEnquiries = async (payload) => {
  return getData("admin/getBespokeEnquiries", payload).then((data) => {
    return data;
  });
};

export const createBespokeEnquiry = async (payload) => {
  return postFormData("admin/createBespokeEnquiry", payload).then((data) => {
    return data;
  });
};

export const updateBespokeEnquiryStatus = async (payload) => {
  return patchFormData("admin/updateBespokeEnquiryStatus", payload).then((data) => {
    return data;
  });
};
